export const commonInputStyles: any = {
  className: "backgroundWhite",
  size: "small",
  variant: "outlined",
  fullWidth: true,
};
